import { render, staticRenderFns } from "./ErpView.vue?vue&type=template&id=34aad1ca&lang=pug"
import script from "./ErpView.vue?vue&type=script&lang=js"
export * from "./ErpView.vue?vue&type=script&lang=js"
import style0 from "./ErpView.vue?vue&type=style&index=0&id=34aad1ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports